export const INBOUND_CALLS_PATH = "/dashboard/inbound_calls";
export const KNOWLEDGE_BANK_PATH = `${INBOUND_CALLS_PATH}/knowledge_bank`;
export const APPOINTMENT_CATEGORIES_PATH = `${INBOUND_CALLS_PATH}/appointment_categories`;
export const PROVIDER_SCHEDULING_PATH = `${INBOUND_CALLS_PATH}/provider_scheduling`;
